import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, batch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {twMerge} from 'tailwind-merge';

import {selectFeatureFlag} from 'App/features/featureFlags/featureFlagsSlice';
import {resetSearch} from 'App/features/search/searchSlice';
import {hideStreetView} from 'App/layout/layoutSlice';
import {cn} from 'App/utils/ui';
import FullLogo from 'Images/buildrz-logo-full.svg?react';
import LogoInner from 'Images/buildrz-logo-inner.svg?react';

type TProps = {
  customLogo?: string;
  fullLogoClassName?: string;
};

function HomeButton({customLogo, fullLogoClassName}: TProps): ReactElement {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const isRedesignAvailable = useSelector(
    selectFeatureFlag('isRedesignAvailable'),
  );

  const handleClick = () => {
    batch(() => {
      dispatch(hideStreetView());
      dispatch(resetSearch());
    });
  };

  const designLogo = isRedesignAvailable ? (
    <FullLogo className={cn('h-full', fullLogoClassName)} />
  ) : (
    <LogoInner />
  );

  return (
    <Link
      onClick={handleClick}
      to="/"
      className={twMerge(
        'block rounded-lg hover:brightness-95 active:brightness-90',
        isRedesignAvailable ? 'h-[50px]' : 'w-[32px]',
      )}
      title={t('Home')}
      data-test="home"
    >
      {(customLogo && <img src={customLogo} alt="home" className="h-full" />) ||
        designLogo}
    </Link>
  );
}

export default HomeButton;
